// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.countdown-wrap {
  text-align: center;
  font-family: sans-serif;
  margin: auto;
}

.countdown-wrap h2 {
  margin-bottom: 1.5rem;
  font-size: 3rem;
  font-weight: 300;
  text-transform: uppercase;
  font-family: serif;
}

.countdown-wrap h2 strong {
  color: #ea4c4c;
}

/* Countdown Styles */
.countdown {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 2rem;
}

.countdown-title {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  font-family: serif;
  color: #666666;
}

.bloc-time {
  text-align: center;
  flex-shrink: 0; /* 要素のサイズが縮小されないように設定 */
  width: 80px; /* 各ブロックの固定幅を指定 */
}

.count-title {
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  color: #666666;
}

.figure {
  font-size: 2.2rem;
  font-weight: bold;
  color: #de4848;
  background-color: #fff;
  border-radius: 1rem;
  padding: 0.5rem 1rem; /* パディングを調整 */
  box-shadow: 0 0.3rem 0.4rem rgba(0, 0, 0, 0.2);
}

/* より自然なメッセージのスタイル */
.limited-offer-message {
  margin-top: 12px;
  background-color: #f8f8f8;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px 12px;
  text-align: center;
  color: #666666;
  font-size: 14px;
  font-weight: normal;
  font-style: italic;
}

.message-text {
  letter-spacing: normal;
}

/* モバイルデバイス用スタイル */
@media screen and (max-width: 768px) {
  .countdown-wrap h2 {
    font-seize: 2rem;
  }
  .countdown {
    gap: 1rem; /* 各ブロック間の余白を縮小 */
  }

  .bloc-time {
    width: 6.5rem; /* 各ブロックの幅を縮小 */
  }

  .figure {
    font-size: 1.8rem; /* フォントサイズを縮小 */
    padding: 0.4rem 0.8rem; /* パディングを調整 */
  }

  .count-title {
    font-size: 0.8rem; /* タイトルのフォントサイズを縮小 */
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/DiscountCountdown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc,EAAE,uBAAuB;EACvC,WAAW,EAAE,iBAAiB;AAChC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB,EAAE,aAAa;EACnC,8CAA8C;AAChD;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE;IACE,gBAAgB;EAClB;EACA;IACE,SAAS,EAAE,iBAAiB;EAC9B;;EAEA;IACE,aAAa,EAAE,eAAe;EAChC;;EAEA;IACE,iBAAiB,EAAE,eAAe;IAClC,sBAAsB,EAAE,aAAa;EACvC;;EAEA;IACE,iBAAiB,EAAE,oBAAoB;EACzC;AACF","sourcesContent":[".countdown-wrap {\n  text-align: center;\n  font-family: sans-serif;\n  margin: auto;\n}\n\n.countdown-wrap h2 {\n  margin-bottom: 1.5rem;\n  font-size: 3rem;\n  font-weight: 300;\n  text-transform: uppercase;\n  font-family: serif;\n}\n\n.countdown-wrap h2 strong {\n  color: #ea4c4c;\n}\n\n/* Countdown Styles */\n.countdown {\n  display: flex;\n  justify-content: center;\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n.countdown-title {\n  font-size: 1.5rem;\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  font-family: serif;\n  color: #666666;\n}\n\n.bloc-time {\n  text-align: center;\n  flex-shrink: 0; /* 要素のサイズが縮小されないように設定 */\n  width: 80px; /* 各ブロックの固定幅を指定 */\n}\n\n.count-title {\n  font-size: 0.9rem;\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  color: #666666;\n}\n\n.figure {\n  font-size: 2.2rem;\n  font-weight: bold;\n  color: #de4848;\n  background-color: #fff;\n  border-radius: 1rem;\n  padding: 0.5rem 1rem; /* パディングを調整 */\n  box-shadow: 0 0.3rem 0.4rem rgba(0, 0, 0, 0.2);\n}\n\n/* より自然なメッセージのスタイル */\n.limited-offer-message {\n  margin-top: 12px;\n  background-color: #f8f8f8;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  padding: 8px 12px;\n  text-align: center;\n  color: #666666;\n  font-size: 14px;\n  font-weight: normal;\n  font-style: italic;\n}\n\n.message-text {\n  letter-spacing: normal;\n}\n\n/* モバイルデバイス用スタイル */\n@media screen and (max-width: 768px) {\n  .countdown-wrap h2 {\n    font-seize: 2rem;\n  }\n  .countdown {\n    gap: 1rem; /* 各ブロック間の余白を縮小 */\n  }\n\n  .bloc-time {\n    width: 6.5rem; /* 各ブロックの幅を縮小 */\n  }\n\n  .figure {\n    font-size: 1.8rem; /* フォントサイズを縮小 */\n    padding: 0.4rem 0.8rem; /* パディングを調整 */\n  }\n\n  .count-title {\n    font-size: 0.8rem; /* タイトルのフォントサイズを縮小 */\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
